module.exports = __webpack_public_path__ + "img/sberbank.6cbc3cf1.png";